import { CoreModule } from "@designboticteam/core";
import { Kolega3DModule } from "@designboticteam/kolega-3d";
import { MapLibreModule } from "@designboticteam/maplibre";
import { MapLibreConnectorModule, MapLibreRendererService, MapToWorkspace3DCameraSyncService } from "@designboticteam/maplibre-connector";
import { createEngineContext } from "@designboticteam/react/context";
import { OrbitCameraControlService, Workspace3DModule } from "@designboticteam/workspace-3d";
import { PALETTE } from "./config/palette";
import { ExchangeModule } from "./engine/exchange";

// get params from URL (maptiler_key)
const urlParams = new URLSearchParams(window.location.search);
const key = import.meta.env.VITE_MAPTILER_KEY ?? urlParams.get("key") ?? "";

const DEFAULT_ORIGIN: [number, number] = [21.0118, 52.2298];
const DEFAULT_ZOOM = 5.5;

const originParam = urlParams.get("origin");
const origin: [number, number] = originParam !== null ? (originParam.split(",").map(Number) as [number, number]) : DEFAULT_ORIGIN;

const zoomParam = urlParams.get("zoom");
const zoom: number = zoomParam !== null ? Number(zoomParam) : DEFAULT_ZOOM;

if (key === "") {
	alert("No key provided in URL params. Please add ?key=YOUR_KEY to the URL.");
	window.location.replace("https://www.designbotic.pl/kolega-space");
}

const { EngineContext, EngineComponent, EngineGate, useEngineApi } = createEngineContext((builder) =>
	builder
		.use(new CoreModule({ palette: PALETTE }))
		.use(
			new MapLibreModule({
				origin,
				zoom,
				style: `https://api.maptiler.com/maps/dataviz-light/style.json?key=${key}`,
				pmTilesSources: [],
			}),
		)
		.use(
			new Workspace3DModule({
				rendererService: MapLibreRendererService,
				cameraControlService: OrbitCameraControlService,
			}),
		)
		.use(new Kolega3DModule())
		.use(
			new MapLibreConnectorModule({
				cameraSyncService: MapToWorkspace3DCameraSyncService,
			}),
		)
		.use(new ExchangeModule()),
);

export { EngineComponent, EngineContext, EngineGate, useEngineApi };
